{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "agent_http",
  "x-feature": true,
  "x-cli-editable": true,
  "x-access": "staff",
  "title": "Agent HTTP endpoint",
  "description": "Let AI agents (Codex, Claude Code, Cursor, agent builders) ask the website agent with a plain link, https://ask.userose.ai/<domain>?q=<question>, with nothing to install. Off by default, enabled per client by staff.",
  "type": "object",
  "properties": {},
  "default": {}
}
